import React from 'react';
import { EPDProductInformationModel } from 'types/types';

import GeographySection from './GeographySection';
import LifespanSection from './LifespanSection';
import MaterialPropertiesSection from './MaterialPropertiesSection';
import ProductClassificationSection from './ProductClassificationSection';
import ProductDetailsSection from './ProductDetailsSection';
import ProductionSitesSection from './ProductionSitesSection';

const ProductDataSection: React.FC<{
  epdId?: string;
  epdVersionId: string;
  product: EPDProductInformationModel | undefined;
  onChange: any;
  errors: any;
  requirePublicationOnOkobaudat: boolean | undefined;
}> = ({ epdId, epdVersionId, product, onChange, errors, requirePublicationOnOkobaudat }) => {
  return (
    <>
      <ProductDetailsSection
        key={product?.id}
        product={product}
        epdId={epdId!}
        epdVersionId={epdVersionId}
        onChange={(name: string, value: any) => onChange(name, value, product?.id as string, epdVersionId)}
        errors={errors}
      />
      <MaterialPropertiesSection
        product={product}
        onChange={(name: string, value: any) => onChange(name, value, product?.id as string, epdVersionId)}
        errors={errors}
      />
      <ProductionSitesSection product={product} epdVersionId={epdVersionId} errors={errors} />
      <ProductClassificationSection
        key={'ProductClassification' + product?.id}
        product={product}
        onChange={(name: string, value: any) => onChange(name, value, product?.id as string, epdVersionId)}
        errors={errors}
      />
      {/* US #9798: Temporarily removed everything Okobaudat-related
      
      {requirePublicationOnOkobaudat && (
        <OkobaudatClassificationSection
          key={'OkobaudatClassification' + product?.id}
          product={product}
          onChange={(name: string, value: any) => onChange(name, value, product?.id as string, epdVersionId)}
          errors={errors}
        />
      )} */}
      <GeographySection
        key={'Geography' + product?.id}
        product={product}
        onChange={(name: string, value: any) => onChange(name, value, product?.id as string, epdVersionId)}
        errors={errors}
      />
      <LifespanSection
        key={'Lifespan' + product?.id}
        product={product}
        onChange={(name: string, value: any) => onChange(name, value, product?.id as string, epdVersionId)}
      />
    </>
  );
};

export default ProductDataSection;
